function getFromAssets(key, currentLocale, folder = 'general', type) {
  const [lang, country] = currentLocale.toLowerCase().split('-');
  const fileLang = country === 'hk' ? `${lang}_${country}/` : '';

  const defaultData = require(`../assets/json/default/setting/${folder}/${type}`);
  const data = require(`../assets/json/${country}/${fileLang}setting/${folder}/${type}`);

  if (typeof data[key] !== 'undefined') {
    return data[key];
  }

  return defaultData[key];
}

function getTranslation(key, currentLocale, folder) {
  return getFromAssets(key, currentLocale, folder, 'locale');
}

function getLink(key, currentLocale, folder) {
  return getFromAssets(key, currentLocale, folder, 'link');
}

function getSetting(key, currentLocale, folder) {
  return getFromAssets(key, currentLocale, folder, 'setting');
}

export { getTranslation, getLink, getSetting };



// WEBPACK FOOTER //
// ./src/service/asset-json.js